// plugins/StoreStateInit.client.ts
// 因在服务端渲染页面用到了dom，所以到client初始化数据
export default defineNuxtPlugin(() => {
  const audioStore = useAudioStore()
  // 只在客户端初始化
  audioStore.initIsOpenSound()
  // 可选：监听路由变化重新初始化（如果需要）
  // nuxtApp.hook('page:start', () => {
  //   soundStore.initIsOpenSound()
  // })
})
